import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTurnstileContext } from "../context/useTurnstileContext";

// WYŁĄCZONE NA CZAS BUDOWANIA STRONY - ustaw na true, żeby włączyć weryfikację Turnstile
const TURNSTILE_ENABLED = false;

export const ProtectedTurnstileRoute = () => {
  const { isSucessValidation } = useTurnstileContext();
  const location = useLocation();

  if (TURNSTILE_ENABLED && !isSucessValidation) {
    return <Navigate to="/verification" replace state={{ from: location }} />;
  }

  return <Outlet />;
};
